<template>
  <div class="page-wrapper">
    <BrandHero :heading="brandConfig.errorHeading"/>

    <p class="body-paragraph">{{ brandConfig.errorText }}</p>

    <div class="spacer"></div>

    <button
        class="accept-btn content-col"
        :style="{ backgroundColor: brandConfig.buttonColor, color: brandConfig.buttonTextColor }"
        @click="onRetryClicked">
      {{ brandConfig.errorCtaLabel }}
    </button>

    <p v-if="reason" class="reason-code">{{ reason }}</p>

    <TermsFooter class="terms-footer-spacing"/>
  </div>
</template>

<script>
import {mapState} from "vuex";
import BrandHero from "@/components/BrandHero.vue";
import TermsFooter from "@/components/TermsFooter.vue";
import {triggerGTMEvent} from "@/functions/addGTM";

export default {
  name: 'ErrorPage',
  components: {BrandHero, TermsFooter},
  data() {
    return {
      reason: null
    }
  },
  computed: {
    ...mapState(['brandConfig'])
  },
  methods: {
    onRetryClicked() {
      triggerGTMEvent('error_retry_clicked');
      this.$router.push({name: 'Landing'});
    }
  },
  mounted() {
    this.reason = new URLSearchParams(window.location.search).get('reason');
    triggerGTMEvent('error_page_view', {error_reason: this.reason || 'unknown'});
  }
}
</script>

<style scoped>
.page-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 38px;
}

.content-col {
  width: min(330px, 100% - 44px);
  margin-left: auto;
  margin-right: auto;
}

.body-paragraph {
  margin-top: 32.4px;
  margin-bottom: 0;
  max-width: 290px;
  margin-left: auto;
  margin-right: auto;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  text-align: center;
  color: #FFFFFF;
}

.spacer {
  flex: 1 1 156px;
  min-height: 156px;
}

.accept-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 66px;
  border: none;
  border-radius: 4px;
  font-family: 'Clash Display', sans-serif;
  font-weight: 600;
  font-size: 15px;
  line-height: 1;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.2s;
}

.accept-btn:hover:not(:disabled) {
  transform: translateY(-2px);
}

.reason-code {
  margin: 12px 0 0;
  font-family: 'Montserrat', sans-serif;
  font-weight: 400;
  font-size: 10px;
  text-align: center;
  color: #6B6B6B;
}

.terms-footer-spacing {
  margin-top: 12.6px;
}
</style>
